export const GET_DELIVERY_ORDERS = 'GET_DELIVERY_ORDERS';
export const SET_DELIVERY_LOADING = 'SET_DELIVERY_LOADING';
export const SET_DELIVERY_FILTER = "SET_DELIVERY_FILTER";